import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  container: {
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 8,
    marginTop: 8,
    marginBottom: 8
  },
  adminRoot: { opacity: '50%' },
  table: {
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 8,
    overflow: 'hidden'
  },
  row: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
    padding: theme.spacing(2),
    alignItems: 'center'
  },
  greyRow: {
    background: theme.palette.grey[200]
  },
  tableHead: {
    background: theme.palette.grey[200],
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
    padding: theme.spacing(2)
  },
  headerRow: {
    backgroundColor: theme.palette.grey[200]
  },
  cell: {
    flex: 1,
    fontWeight: 600
  },
  divider: {
    width: '100%'
  },
  success: {
    color: theme.palette.secondary.main
  },
  failed: {
    color: theme.palette.primary.main
  },
  reserved: {
    color: theme.palette.info.main
  },
  primitive: {
    color: theme.palette.secondary.light
  },
  confirmed: {
    color: theme.palette.secondary.main
  },
  blackText: { fontWeight: 600, color: theme.palette.text.primary },
  header: { padding: theme.spacing(2) },
  bottom: { padding: theme.spacing(2) },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center'
  }
}))
